import { useFormStatus } from 'Forms/forms.hooks';
import { useEffect } from 'react';

interface ScrollToFieldErrorProps {
  alertRef: React.RefObject<HTMLDivElement>;
}

export const ScrollToFieldError = ({
  alertRef,
}: ScrollToFieldErrorProps): null => {
  const { submitSuccess } = useFormStatus();
  useEffect(() => {
    if (alertRef.current) {
      alertRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  }, [alertRef, submitSuccess]);
  return null;
};
